import { DealActions, DealDetail, DealSubscriptionIdentifier, EntityTypeEnum, SubscriptionIdentifier } from 'api'
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createDealDetailsSelector } from 'selectors/dealSelectors'
import { createEntitySubscriptionSelector } from 'selectors/selectionSelectors'
import { SubscriptionDetail } from 'store/selection/selectionTypes'
import { DealsScreenBase } from './components/DealsScreenBase/DealsScreenBase'
import { DealsHeroPanelBase } from './components/DealsScreenBase/DealsHeroPanelBase'
import { Translation } from 'locale'
import { RollsDealsSubscriptionFilters } from 'view/components/datagrid/filters/RollsDealsSubscriptionFilters'
import { GridId } from 'store/grid'
import { generateExportFileName } from 'view/components/datagrid/gridUtils/utils'

interface RollsDealsScreenComponentProps {
  dealDetails: DealDetail[]
  subscriptionDetail: SubscriptionDetail | undefined
  onPageSubscribe: typeof DealActions.pageSubscribe
}

const mapStateToProps = createStructuredSelector({
  dealDetails: createDealDetailsSelector([DealSubscriptionIdentifier.ROLLS]),
  subscriptionDetail: createEntitySubscriptionSelector(
    () => EntityTypeEnum.DEAL,
    () => SubscriptionIdentifier.ROLLS
  )
})

const mapDispatchToProps = {
  onPageSubscribe: DealActions.pageSubscribe
}

export const RollsDealsScreenComponent: React.FC<RollsDealsScreenComponentProps> = props => {
  const { dealDetails, subscriptionDetail, onPageSubscribe } = props

  const onPageChanged = (pageNumber: number) => {
    if (subscriptionDetail) {
      onPageSubscribe(SubscriptionIdentifier.ROLLS, subscriptionDetail.filters, pageNumber)
    }
  }

  return (
    <DealsScreenBase
      dealDetails={dealDetails}
      subscriptionDetail={subscriptionDetail}
      subscriptionFilter={<RollsDealsSubscriptionFilters subscriptionDetail={subscriptionDetail} />}
      onPageChanged={onPageChanged}
      gridId={GridId.RollsGrid}
      exportFileName={generateExportFileName('Rolls')}>
      <DealsHeroPanelBase
        dealList={dealDetails}
        tearoutRoute={'/quote/tearout/rolls'}
        heroTitle={Translation.TC_HERO_ROLLS}
        bannerTitle={Translation.TC_DEALS}
      />
    </DealsScreenBase>
  )
}

export const RollsDealsScreen = connect(mapStateToProps, mapDispatchToProps)(RollsDealsScreenComponent)
